import wixData from 'wix-data';
import wixUsers from 'wix-users';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';

let product;
let user;
let userEmail;

$w.onReady(async function () {
	// console.log("onReady")

	if (wixWindow.rendering.env === "browser") {
		user = wixUsers.currentUser;
		product = await $w('#productPage1').getProduct();
		console.log(user.loggedIn);
		if (user.loggedIn) {
			user.getEmail()
				.then((email) => {
					userEmail = email; // "user@something.com"
				});
		}

		initReviews();
		checkWishlist();
		loadRelatedProducts();

		try {
			$w('#loginMessage').onClick(loginMessageClick);
		} catch (err) {
			console.log("component does not exist on Mobile")
		}
	}

});

async function addToWishlist() {
	console.log("addToWishlist")
	console.log(["product: " + product._id, "userId: " + user.id, "userEmail: " + userEmail, "productName: " + product.name, "productImage: " + product.mainMedia])

	let wishListItem = {
		product: product._id,
		userId: user.id,
		userEmail: userEmail,
		productName: product.name,
		productImage: product.mainMedia,
		productPrice: product.formattedPrice,
		productDiscountedPrice: product.formattedDiscountedPrice,
		productUrl: product.productPageUrl
	};

	let result = await wixData.insert("Wishlist", wishListItem);
}

async function removeFromWishlist() {
	console.log("removeFromWishlist")
	let wishListResult = await wixData.query("Wishlist")
		.eq("product", product._id)
		.eq("userId", user.id)
		.find();

	if (wishListResult.length > 0) {
		$w('#notInWishList').show('fade', { duration: 100 });
		$w('#inWishList').hide('fade', { duration: 100 });
		await wixData.remove("Wishlist", wishListResult.items[0]._id)
	}
}

async function checkWishlist() {
	console.log("checkWishlist")
	if (wixUsers.currentUser.loggedIn) {
		let wishListResult = await wixData.query("Wishlist")
			.eq("product", product._id)
			.eq("userId", user.id)
			.find();

		console.log(wishListResult);
		if (wishListResult.items.length > 0) {
			$w('#inWishList').show('fade', { duration: 100 });
		} else {
			$w('#notInWishList').show('fade', { duration: 100 });
		}
	} else {
		$w('#notInWishList').show('fade', { duration: 100 });
	}
}

async function loginMessageClick() {
	console.log("loginMessageClick")
	let options = { "mode": "login" };
	$w('#loginMessage').hide();
	await wixUsers.promptLogin(options);
}

export function notInWishList_click(event, $w) {
	console.log("notInWishList_click")
	if (user.loggedIn) {
		addToWishlist();
		$w('#notInWishList').hide('fade', { duration: 100 });
		$w('#inWishList').show('fade', { duration: 100 });
	} else
		$w('#loginMessage').show();
}

export function inWishList_click(event, $w) {
	console.log("inWishList_click")
	if (user.loggedIn)
		removeFromWishlist();
}

//------------- Reviews -------------------------------------------------------------------------------//

async function initReviews() {
  await $w('#Reviews').setFilter(wixData.filter().eq('productId', product._id));
  showReviews();
  loadStatistics();
}

async function loadStatistics() {
    const stats = await wixData.get('review-stats', product._id);
    if (stats) {
        let avgRating = (Math.round(stats.rating * 10 / stats.count) / 10);
        let percentRecommended = Math.round(stats.recommended / stats.count * 100);
        let ratings = $w('#generalRatings');
        ratings.rating = avgRating;
        ratings.numRatings = stats.count;
        $w('#recoPercent').text = `${percentRecommended} % מהחברות ממליצות`;
        $w('#generalRatings').show();
    } else {
        $w('#recoPercent').text = 'אין עדיין המלצות למוצר הזה';
    }
    $w('#recoPercent').show();
}

// Perform some setup when the dataset filter was completed.
export function showReviews() {
	// If at least one review has been submitted:
	if ($w('#Reviews').getTotalCount() > 0) {
		// Expand the strip that displays the reviews.
		$w('#reviewsStrip').expand();
	// If there are no reviews:
	} else {
		// Collapse the strip that displays the reviews.
		$w('#reviewsStrip').collapse(); //otherwise, hide it
	}
}

//------------- Related Products -------------------------------------------------------------------------------//

// Load the products that are related to the currently displayed product.
async function loadRelated() {
	console.log("loadRelatedProducts Starts")
	// Get the current product's data.
	let relatedProduct = await $w('#productPage1').getProduct();
	// Get the related product results using the relatedProductsByCollection() and relatedProductsByPrice() functions.

	console.log(relatedProduct)

	let relatedProductResults = await Promise.all([
		relatedProductsByCollection(relatedProduct),
		relatedProductsByPrice(relatedProduct)
	]);
	console.log(relatedProductResults);

	// If there are related products found in the "related-products" collection:	
	if (relatedProductResults[0].length > 0)
		// Show the related products from the collection.
		showRelatedProducts(relatedProductResults[0]);
	// If there are no related products found in the "related-products" collection:	
	else
		// Fallback to showing the related products by price.
		showRelatedProducts(relatedProductResults[1]);
}

// Get related products based on the relations set in the "related-products" collection.
async function relatedProductsByCollection(product) {
	// Get the current product's ID.
	let productId = product._id;

	// Find related products in the relationship collection by querying for related products in both relation directions.
	let relatedByTable = await Promise.all([
		wixData.query('related-products')
		.eq('productA', productId)
		.include('productB')
		.find(),
		wixData.query('related-products')
		.eq('productB', productId)
		.include('productA')
		.find()
	]);

	// Merge related products found from both sides of the relationship collection.
	let relatedProducts = [
		...relatedByTable[0].items.map(_ => _.productB),
		...relatedByTable[1].items.map(_ => _.productA)
	];

	//Return the related products found in the collection.
	return relatedProducts;
}

// Get related products based on the the product prices.
async function relatedProductsByPrice(product) {
	// Get the current product's ID.
	let productId = product._id;

	// Query the "Products" collection for product's whose price is within 20% of the current product's price.
	let relatedByPrice = await wixData.query('Stores/Products')
		.between('price', product.price * 0.8, product.price * 1.2)
		.ne('_id', productId)
		.find();
	// Return the related items extracted from the query results.
	return relatedByPrice.items;
}

// Show the related products on the page.
function showRelatedProducts(relatedProducts) {
	// If there are any related products:
	if (relatedProducts.length > 0) {
		// Remove all but the first four related items.
		relatedProducts.splice(3, relatedProducts.length);
		// Set the function that runs when the related items repeater data is loaded to be relatedItemReady().
		$w('#relatedItemsRepeater').onItemReady(relatedItemReady);
		// Set the related items repeater data to the first three related items.
		$w("#relatedItemsRepeater").data = relatedProducts;
		// Expand the related items repeater.
		$w("#relatedItems").expand();
	}
	// If there are no related products:
	else {
		// Collapse the related items repeater.
		$w("#relatedItems").collapse();
	}
}

// Set up the related items repeater as its data is loaded.
function relatedItemReady($w, product) {
	// Populate the repeater elements from the item data.
	$w("#productImage").src = product.mainMedia;
	$w("#productName").text = product.name;
	$w("#productPrice").text = product.formattedDiscountedPrice;
	// Set the action that occurs when the image is clicked.
	$w('#productImage').onClick(() => {
		// Navigate to the related product's product page.
		wixLocation.to(product.productPageUrl);
	});
}

// Set up each item in the reivews repeater as it is loaded.
export function reviewsRepeater_itemReady($item, itemData, index) {

	if (itemData.recommends) {
        $w('#recommendation').text = 'המלצתי על המוצר הזה!';
    } else {
        $w('#recommendation').text = "לא";
    }
    if (itemData.photo) {
        $w('#reviewImage').src = itemData.photo;
        $w('#reviewImage').expand();
    }
    $w('#oneRating').rating = itemData.rating;
    let date = itemData._createdDate;
    $w('#submissionTime').text = date.toLocaleString();
}

export async function addReview_click(event) {
	const dataForLightbox = {
        productId: product._id
    };
	let result = await wixWindow.openLightbox('Review Box', dataForLightbox);
    $w('#Reviews').refresh();
    loadStatistics();
    $w('#thankYouMessage').show();
}

export function resultsPages_click(event) {
	$w('#Reviews').loadMore();
}